import { NgModule } from '@angular/core';
import { RibbonDirective } from './ribbon.directive';

@NgModule({
    declarations: [
        RibbonDirective
    ],
    imports: [],
    exports: [
        RibbonDirective
    ]
})
export class NcRibbonModule { }